import { render, staticRenderFns } from "./Sozialinfo.vue?vue&type=template&id=51e8242d&scoped=true"
import script from "./Sozialinfo.vue?vue&type=script&lang=js"
export * from "./Sozialinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e8242d",
  null
  
)

export default component.exports